import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations/translations';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

const Contact = () => {
  const { language } = useLanguage();
  const { darkMode } = useTheme();
  const [showEmail, setShowEmail] = useState(false);

  const emailParts = ['william', 'jxmedia', 'no'];
  const getEmail = () => `${emailParts[0]}@${emailParts[1]}.${emailParts[2]}`;

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <SEO
        title="Kontakt oss"
        path="/contact"
        description="Ta kontakt med Effekt for spørsmål om elbiltester, samarbeid eller tips."
      />
      <div className="max-w-4xl w-full text-center">
        <h1 className="sr-only">Kontakt Effekt</h1>
        <p className={`text-2xl sm:text-3xl md:text-4xl mb-12 leading-relaxed font-light max-w-3xl mx-auto ${darkMode ? 'text-gray-300' : 'text-stone-600'}`}>
          {t(language, 'contact.message')}
        </p>

        <div className="mt-12">
          {!showEmail ? (
            <button
              onClick={() => setShowEmail(true)}
              className="px-10 py-5 bg-teal-500 hover:bg-teal-400 text-white font-bold rounded-xl transition-all duration-150 shadow-lg text-xl"
            >
              {t(language, 'contact.showEmail')}
            </button>
          ) : (
            <div className={`rounded-2xl p-8 border inline-block ${darkMode ? 'bg-slate-800 border-teal-500 border-opacity-30' : 'bg-white border-stone-200 shadow-md'}`}>
              <p className={`mb-4 font-semibold text-lg ${darkMode ? 'text-gray-300' : 'text-stone-600'}`}>
                {t(language, 'contact.emailLabel')}
              </p>
              <a
                href={`mailto:${getEmail()}`}
                className="text-3xl font-bold text-teal-500 hover:text-teal-400 transition-colors duration-150"
              >
                {getEmail()}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
